<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:65%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <!-- <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["CMS"]["AWMT"]}}</h4> -->
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["CMS"][obj_awt.I > 0? "EFC": "AFC"]}}</h4>

                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["CMS"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              v-model="obj_awt['AGIT']"
                                                              @input="AgentGroupChange"
                                                              :disabled="obj_awt.I > 0"
                                                              ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','CMS','BN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["CMS"]["DN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_do"
                                                        :placeholder="this.utilGetDDLanguage('FC.DN')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        v-model="obj_awt['DI']"
                                                        :disabled="obj_awt.I > 0"
                                                        @input="DomainChange"
                                                        ref="DI" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('DI','CMS','DN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["CFM"]["FS"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 15px">
                                        <CCol col="6">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage["CMS"]["FDC"]}}
                                            </p>
                                            <div class='subHeaderHR'></div>

                                            <CRow>
                                                <CCol col="1">
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="boolSBL" @change="v => boolSBL = v.target.checked" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol>
                                                    <label class="ACUZ_DO col-form-label">
                                                        {{this.getLanguage["CMS"]["SBL"]}}
                                                        <div class="custom-tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2">{{getLanguage["CFM"]["FT10B"]}}</span>
                                                        </div>
                                                    </label>
                                                </CCol>
                                            </CRow>
                                            <!--Bank List-->
                                            <CRow v-if="boolSBL == true && obj_awt.BankList != null && obj_awt.BankList.length > 0" class="modal-main-content" style="max-height: 20vh; margin-bottom: 15px; padding-left: 15px; padding-right: 10px; width: 100%;">
                                                <table class="custom-table afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th style="width: 150px;">{{this.getLanguage['BANK']['BC']}}</th>
                                                            <th style="width: 200px;">{{this.getLanguage['BANK']['BN']}}</th>
                                                            <th style="width: 50px;">{{this.getLanguage['BTN']['HD']}}</th>
                                                            <!--<th style="width: 90px;">
                                                                {{//this.getLanguage['BANK']['SN']}}
                                                                <div class="custom-tooltip">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 bank-seqno">{{//getLanguage["CMS"]["SNN"]}}</span>
                                                                </div>
                                                            </th>-->

                                                        </tr>
                                                    </thead>
                                                    <draggable v-model="obj_awt.BankList" tag="tbody">
                                                        <tr v-for="(data,index) in obj_awt.BankList.filter(f=>f.RS!=0)" :key="index" style="cursor: move">
                                                            <td class="py-2">{{ index+1 }}</td>
                                                            <td class="py-2">{{ data.BC }}</td>
                                                            <td class="py-2">{{ data.BN }}</td>
                                                            <td class="py-2" style="margin:auto;"><input style="margin:auto;" type="checkbox" :true-value="1" :false-value="0" v-model="data.IHBL" @change="handleCheckboxChange(index)"></td>
                                                            <!--<td>
        <CInput size="sm" vertical :value="data.SN" @change="v=>data.SN=checkSeqNo(data,v,'BLSQN_'+index)" :id="'BLSQN_'+index"></CInput>
    </td>-->
                                                        </tr>
                                                    </draggable>
                                                </table>
                                                <br />
                                            </CRow>
                                            <CRow>
                                                <CCol col="1">
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="boolSGL" @change="v => boolSGL = v.target.checked" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["CMS"]["SGL"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <CRow>
                                                <CCol col="1">
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="boolSGP" @change="v => boolSGP = v.target.checked" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["CMS"]["SGP"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <CRow style="margin-left: 50px;">
                                                <CCol col="1">
                                                    <input type="radio" name="gpstyle" :checked="bool_gps_one" :disabled="!boolSGP" value="1" @change="v => str_gpStyle = v.target.value">
                                                </CCol>
                                                <CCol>
                                                    <label for="html">{{this.getLanguage["CMS"]["GPS1"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <CRow style="margin-left: 50px;">
                                                <CCol col="1">
                                                    <input type="radio" name="gpstyle" :checked="bool_gps_two" :disabled="!boolSGP" value="2" @change="v => str_gpStyle = v.target.value">
                                                </CCol>
                                                <CCol>
                                                    <label for="html">{{this.getLanguage["CMS"]["GPS2"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <CRow style="margin-left: 50px;">
                                                <CCol col="1">
                                                    <input type="radio" name="gpstyle" :checked="bool_gps_three" :disabled="!boolSGP" value="3" @change="v => str_gpStyle = v.target.value">
                                                </CCol>
                                                <CCol>
                                                    <label for="html">{{this.getLanguage["CMS"]["GPS3"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <CRow>
                                                <CCol col="1">
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="boolSSP" @change="v => boolSSP = v.target.checked" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["CMS"]["SSP"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <CRow>
                                                <CCol col="1">
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="boolSEP" @change="v => boolSEP = v.target.checked" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["CMS"]["SEP"]}}</label>
                                                </CCol>
                                            </CRow>

                                            <!-- <CRow>
                <CCol col="1">
                    <label class="switch">
                        <input type="checkbox" :checked="boolSPB" @change="v => boolSPB = v.target.checked" />
                        <span class="slider round"></span>
                    </label>
                </CCol>
                <CCol>
                    <label class="ACUZ_DO col-form-label">{{//this.getLanguage["CMS"]["SPB"]}}</label>
                </CCol>
            </CRow> -->

                                        </CCol>

                                        <CCol col="6">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage["CMS"]["IS"]}}
                                            </p>
                                            <div class='subHeaderHR'></div>

                                            <CRow>
                                                <CCol col="1">
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="boolBigImg" @change="v => boolBigImg = v.target.checked" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["CMS"]["LIS"]}}</label>
                                                </CCol>
                                            </CRow>

                                        </CCol>
                                    </CRow>
                                    <!--========= Custom Menu =======-->
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["CFM"]["CMM"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 15px">
                                        <CCol col="6">
                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm">{{this.getLanguage["CFM"]["CMM"]}} :</label>
                                                    <div class="d-flex" style="gap:10px;">
                                                        <treeselect :multiple="false"
                                                                    :options="dd_main_menu"
                                                                    :placeholder="this.utilGetDDLanguage('CFM.CMM')"
                                                                    v-model="main_menu"
                                                                    ref="NMM" />
                                                        <CButton color="outline-info" size="sm" @click="addNMM()" style="min-width: 100px;" v-if="main_menu">
                                                            <span class='plusIcon cil-plus'></span>
                                                            {{ this.getLanguage["BTN"]["AN"] }}
                                                        </CButton>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                            <br/>
                                                <table class="custom-table afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 60px;text-align:center">{{this.getLanguage["GL"]["ACT"]}}</th>
                                                            <th style="width: 200px;">{{this.getLanguage['CFM']['CMM']}}</th>
                                                            <!--<th style="width: 90px;">
                                                                {{this.getLanguage['BANK']['SN']}}
                                                                <div class="custom-tooltip">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 bank-seqno">{{getLanguage["CMS"]["SNN"]}}</span>
                                                                </div>
                                                            </th>-->
                                                        </tr>
                                                    </thead>
                                                    <draggable v-model="obj_awt.MainMenu" tag="tbody">
                                                        <tr v-for="(data,index) in obj_awt.MainMenu.filter(f=>f.RS!=0)" :key="index" style="cursor: move">
                                                            <td class="py-2">
                                                                <span id="actionBtnCol">
                                                                    <div class="custom-tooltip" v-if="dd_main_menu.find(f => f.id == data.MMI)">
                                                                        <i class="cil-trash sortlogo" @click="removeMainMenu(data.I, data.NMI)"></i>
                                                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                    </div>
                                                                    <div class="custom-tooltip">
                                                                        <i class="cil-color-border sortlogo" @click="editMainMenu(data)"></i>
                                                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                                    </div>
                                                                </span>
                                                            </td>
                                                            <td class="py-2">{{ renderCategoryNameForafbMainMenu(data.MN) }}</td>
                                                            <!--<td>
                                                                <CInput size="sm" vertical :value="data.SN" @change="v=>data.SN=checkNavSeqNo(data,v,'SN_2_'+index)" :id="'SN_2_'+index"></CInput>
                                                            </td>-->
                                                        </tr>
                                                    </draggable>
                                                </table>
                                        </CCol>
                                    </CRow>

                                    <!--========= Custom Bottom Menu =======-->
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>3</span>{{this.getLanguage["CFM"]["CBNM"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 15px">
                                        <CCol col="6">
                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm">{{this.getLanguage["CFM"]["BNM"]}} :</label>
                                                    <div class="d-flex" style="gap:10px;">
                                                        <treeselect :multiple="false"
                                                                    :options="dd_nav_menu"
                                                                    :placeholder="this.utilGetDDLanguage('CFM.BNM')"
                                                                    v-model="nav_menu"
                                                                    ref="BNM" />
                                                        <CButton color="outline-info" size="sm" @click="addBNM()" style="min-width: 100px;" v-if="nav_menu">
                                                            <span class='plusIcon cil-plus'></span>
                                                            {{ this.getLanguage["BTN"]["AN"] }}
                                                        </CButton>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol md="8">
                                                    <label class="col-form-label-sm">{{this.getLanguage["CFM"]["HDC"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_DisplayContent"
                                                                :placeholder="this.utilGetDDLanguage('CFM.HDC')"
                                                                :clearable="false"
                                                                v-model="obj_awt.HDC"
                                                                ref="HDC" />
                                                    <span class="ErrMsg">{{ ValidationErrMsg('HDC','CFM','HDC') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="6">
                                            <CRow>
                                                <CCol>
                                                    <label class="col-form-label-sm">{{getLanguage["CFM"]["CBGC"]}} :</label><br>
                                                    <label class="switch">
                                                        <input type="checkbox" :checked="obj_awt.ICC" v-model="obj_awt.ICC" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                            </CRow>
                                            <CRow v-if="obj_awt.ICC">
                                                <CCol>
                                                    <label class="col-form-label-sm">{{this.getLanguage["CFM"]["BGC"]}}<span class="required" /> :</label>
                                                    <swatches :value="obj_awt.BGC" @close="TCColorChange" fallback-input-type="color" show-fallback colors="text-advanced" popover-to="left"></swatches>
                                                    <span class="ErrMsg">{{ ValidationErrMsg('BGC','CFM','BGC') }}</span>
                                                </CCol>
                                                <CCol>
                                                    <label class="col-form-label-sm">{{this.getLanguage["CFM"]["BGBC"]}}<span class="required" /> :</label>
                                                    <swatches :value="obj_awt.BGBC" @close="TBCColorChange" fallback-input-type="color" show-fallback colors="text-advanced" popover-to="left"></swatches>
                                                    <span class="ErrMsg">{{ ValidationErrMsg('BGBC','CFM','BGBC') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 15px">
                                        <CCol col="6">
                                            <strong>{{ this.getLanguage["CFM"]["BLOG"] }}</strong>
                                            <table class="custom-table afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 60px; text-align: center">{{this.getLanguage["GL"]["ACT"]}}</th>
                                                        <th style="width: 200px;">{{this.getLanguage['CFM']['BNM']}}</th>
                                                        <!--<th style="width: 90px;">
                                                            {{//this.getLanguage['BANK']['SN']}}
                                                            <div class="custom-tooltip">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 bank-seqno">{{//getLanguage["CMS"]["SNN"]}}</span>
                                                            </div>
                                                        </th>-->

                                                    </tr>
                                                </thead>
                                                <draggable v-model="obj_awt.CustomNavMenu" tag="tbody">
                                                    <tr v-for="(data,index) in obj_awt.CustomNavMenu.filter(f=>f.RS!=0)" :key="index" v-if="data.BAL==1" style="cursor: move ">
                                                        <td class="py-2">
                                                            <span id="actionBtnCol">
                                                                <div class="custom-tooltip">
                                                                    <i class="cil-trash sortlogo" @click="removeNavMenu(data.I, data.NMI, data.BAL)"></i>
                                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                </div>
                                                                <div class="custom-tooltip">
                                                                    <i class="cil-color-border sortlogo" @click="editMenu(data)"></i>
                                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                                </div>
                                                            </span>
                                                        </td>
                                                        <td class="py-2">{{ renderCategoryNameForBottomNav(data.MN) }} </td>
                                                        <!--<td>
                                                            <CInput size="sm" vertical :value="data.SN" @change="v=>data.SN=checkNavSeqNo(data,v,'SN_2_'+index)" :id="'SN_2_'+index"></CInput>
                                                        </td>-->
                                                    </tr>
                                                </draggable>
                                            </table>
                                        </CCol>
                                        <CCol col="6">
                                            <strong class="mr-3">{{ this.getLanguage["CFM"]["ALOG"] }}</strong>
                                            <input type="checkbox" :checked="obj_awt.SABL" @change="v => obj_awt.SABL = v.target.checked" /> {{ this.getLanguage["CFM"]["SABLOG"] }}
                                            <table class="custom-table afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 60px; text-align: center">{{this.getLanguage["GL"]["ACT"]}}</th>
                                                        <th style="width: 200px;">{{this.getLanguage['CFM']['BNM']}}</th>
                                                        <!--<th style="width: 90px;">
                                                            {{//this.getLanguage['BANK']['SN']}}
                                                            <div class="custom-tooltip">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 bank-seqno">{{//getLanguage["CMS"]["SNN"]}}</span>
                                                            </div>
                                                        </th>-->
                                                    </tr>
                                                </thead>
                                                <draggable v-model="obj_awt.CustomNavMenu" tag="tbody">
                                                    <tr v-for="(data,index) in obj_awt.CustomNavMenu.filter(f=>f.RS!=0)" :key="index" v-if="data.BAL==2" style="cursor: move ">
                                                        <td class="py-2">
                                                            <span id="actionBtnCol">
                                                                <div class="custom-tooltip">
                                                                    <i class="cil-trash sortlogo" @click="removeNavMenu(data.I, data.NMI, data.BAL)"></i>
                                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                </div>
                                                                <div class="custom-tooltip">
                                                                    <i class="cil-color-border sortlogo" @click="editMenu(data)"></i>
                                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                                </div>
                                                            </span>
                                                        </td>
                                                        <td class="py-2">{{ renderCategoryNameForBottomNav(data.MN) }}</td>
                                                        <!--<td>
                                                            <CInput size="sm" vertical :value="data.SN" @change="v=>data.SN=checkNavSeqNo(data,v,'SN_2_'+index)" :id="'SN_2_'+index"></CInput>
                                                        </td>-->
                                                    </tr>
                                                </draggable>
                                            </table>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveCMS()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isBNM">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:35%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["CFM"]["BNML"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeBNM()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["CFM"]["BNM"]}}:</label>
                                            <CInput size="sm" :value="obj_BNM.MN" disabled />
                                        </CCol>
                                        <CCol md="6" v-if="needURL(obj_BNM.NMI)">
                                            <label class="col-form-label-sm">{{this.getLanguage["CU"]["URL"]}}<span class="required" /> :</label>
                                            <CInput size="sm" v-model="obj_BNM.URL" />
                                            <span class="ErrMsg">{{ ValidationBNMErrMsg('URL','CU','URL') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["CFM"]["LS"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow id="webTempSetting" v-if="dd_lang && dd_lang.length">
                                        <CCol md="5">
                                            <div class="nav flex-column nav-pills h-100" aria-orientation="vertical">
                                                <a :class="(selectedLang.id == data.id) ? 'd-flex nav-link active' : 'd-flex nav-link'" style="cursor:pointer" v-for="(data, index) in dd_lang" @click="selectedLang = data">
                                                    <div class="d-flex align-items-center ml-3">
                                                        <span class="flagClass mr-2" :class="mapLanguageFlag(data.id)"></span>
                                                        <span>{{data.label}}</span>
                                                    </div>
                                                </a>
                                            </div>
                                        </CCol>
                                        <CCol md="7">
                                            <label class="col-form-label-sm font-weight-bold d-block">{{selectedLang.label}}</label>
                                            <label class="col-form-label-sm">{{this.getLanguage["CFM"]["BNMN"]}}:</label>
                                            <CInput size="sm" v-model="obj_BNM.TMNL[data.id]" v-for="(data, index) in dd_lang" :key="index" v-if="selectedLang.id == data.id" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveMenu()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMM">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:35%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["CFM"]["CMML"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeMM()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["CFM"]["CMM"]}}:</label>
                                            <CInput size="sm" :value="obj_MM.MN" disabled />
                                        </CCol>                                        
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["CFM"]["LS"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow id="webTempSetting" v-if="dd_lang && dd_lang.length">
                                        <CCol md="5">
                                            <div class="nav flex-column nav-pills h-100" aria-orientation="vertical">
                                                <a :class="(selectedLang.id == data.id) ? 'd-flex nav-link active' : 'd-flex nav-link'" style="cursor:pointer" v-for="(data, index) in dd_lang" @click="selectedLang = data">
                                                    <div class="d-flex align-items-center ml-3">
                                                        <span class="flagClass mr-2" :class="mapLanguageFlag(data.id)"></span>
                                                        <span>{{data.label}}</span>
                                                    </div>
                                                </a>
                                            </div>
                                        </CCol>
                                        <CCol md="7">
                                            <label class="col-form-label-sm font-weight-bold d-block">{{selectedLang.label}}</label>
                                            <label class="col-form-label-sm">{{this.getLanguage["CFM"]["CMMN"]}}:</label>
                                            <CInput size="sm" v-model="obj_MM.TMNL[data.id]" v-for="(data, index) in dd_lang" :key="index" v-if="selectedLang.id == data.id" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveMainMenu()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <!-- <h2 id="titleHeight">{{this.getLanguage["CMS"]["CMS"]}}</h2> -->
                        <h2 id="titleHeight">{{this.getLanguage["CMS"]["FC"]}}</h2>
                        <CButton size="sm" v-if="checkModuleAccess2(constAccessType.add)" color="outline-info" @click="addCMS()"><span class='plusIcon cil-plus'></span>{{ this.getLanguage["BTN"]["AN"] }}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["CMS"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["CMS"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('CMS.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[1].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{ this.getLanguage["BTN"]["SR"] }}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <!-- <strong>{{this.getLanguage["CMS"]["WMTL"]}}</strong> -->
                    <strong>{{this.getLanguage["CMS"]["FCL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{this.getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["CMS"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["CMS"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["CMS"]["SBL"]}}</th>
                                <th>{{this.getLanguage["CMS"]["SGL"]}}</th>
                                <th>{{this.getLanguage["CMS"]["SGP"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{this.getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["CMS"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["CMS"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["CMS"]["SBL"]}}</th>
                                <th>{{this.getLanguage["CMS"]["SGL"]}}</th>
                                <th>{{this.getLanguage["CMS"]["SGP"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_wtl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_wtl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-trash" @click="removeCMS(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editCMS(data.I)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{data.GN}} ({{data.PC}})</td>
                            <td>{{data.DN}}</td>
                            <td>{{checkStatus(data.SB)}}</td>
                            <td>{{checkStatus(data.SGL)}}</td>
                            <td>{{checkStatus(data.SGP)}}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import moment from "moment";
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import Swatches from 'vue-swatches';
    import "vue-swatches/dist/vue-swatches.min.css";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';
    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Swatches,
            draggable
        },
        props: {

        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_CVBNM: false, // Check Validation
                bool_CVMM: false, // Check Validation
                bool_isBNM: false, // Add Modal Visible
                bool_isMM: false, // Add Modal Visible
                bool_showSearchBar: true,
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "DI" }, { F: "RS" }, {
                    F: "CTS", FV: {
                        startDate: "",
                        endDate: ""
                    }
                }], //Filter Value
                dd_do: [], // Domain Option
                dd_dofs: [], // Domain Option for search
                obj_awt: {},
                arry_wtl: [],
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                FMStatus: [],
                boolSBL: false,
                boolSGL: false,
                boolSGP: false,
                boolSSP: false,
                boolSPB: false,
                boolSEP: false,
                boolBigImg: false,
                bool_gps_one: true,
                bool_gps_two: false,
                bool_gps_three: false,
                str_gpStyle: "1",
                constAccessType: constAccessType,
                dd_nav_menu: [],
                dd_main_menu: [],
                obj_BNM: {},
                obj_MM: {},
                dd_lang:[],
                dd_DisplayContent: [],
                selectedLang: null,
                nav_menu: null,
                main_menu: null,
                isDragDropBankList: false,
                isDragDropMainMenu: false,
                isDragDropNavMenu: false
            }
        },
        validations: {
            obj_awt: {
                AGIT: { required },
                DI: { required },
                HDC: { required },
                BGC: {
                    required: requiredIf(function (vm) {
                        return vm.ICC;
                    })
                },
                BGBC: {
                    required: requiredIf(function (vm) {
                        return vm.ICC;
                    })
                },
            },
            obj_BNM: {
                URL: {
                    required: requiredIf(function (vm) {
                        return this.needURL(vm.NMI);
                    })
                },
            }
        },
        created() {
            this.$parent.showSubMenu = 'CMS';
            this.$parent.showActiveMenu = 'CMS.CMSDU';
            if (this.$route.path == '/WEBS/CMSDU') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showSubSubMenu = 'CMS1';
                this.$parent.showActiveMenu = 'WEBS.CMSDU';
            }
            this.getFMStatus();
            this.getDropDownList();
            this.getCMSList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            handleCheckboxChange(index) {
                if (this.obj_awt.BankList != null && this.obj_awt.BankList.length > index)
                {
                    this.obj_awt.BankList[index].IsEdit = true;
                }
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('CMSDU', 'CMS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            renderStatus(index) {
                return this.FMStatus[index - 1].label;
            },
            getFMStatus() {
                this.FMStatus = constStatus;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getCMSList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getCMSList();
                }
            },
            checkStatus(RS) {
                //var a = this.$parent.checkStatus(RS + 1);
                if (RS >= 1) {
                    return this.getLanguage['BTN']['SW'];
                } else {
                    return this.getLanguage['BTN']['HD'];
                }
            },
            getDropDownList() {
                var that = this;
                this.dd_DisplayContent = [{ id: 1, label: this.getLanguage['CFM']['HI'] }, { id: 2, label: this.getLanguage['CFM']['SL'] }];
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
                this.getDataApi(`/api/dd/bnm`,
                    function (d, s) {
                        if (s) {
                            that.dd_nav_menu = d.dropdownlist
                            for (var i = 0; i < that.dd_nav_menu.length; i++) {
                                that.dd_nav_menu[i].label = that.renderCategoryNameForBottomNav(that.dd_nav_menu[i].label.replaceAll(" ", ""))
                            }
                        }
                    });
                this.getDataApi(`/api/dd/nmm`,
                    function (d, s) {
                        if (s) {
                            that.dd_main_menu = d.dropdownlist
                            for (var i = 0; i < that.dd_main_menu.length; i++) {
                                that.dd_main_menu[i].label = that.renderCategoryNameForafbMainMenu(that.dd_main_menu[i].label.replaceAll(" ", ""))
                            }
                        }
                    });

            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[0].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                }


            },
            AgentGroupChange(value, loadBankList = true) {
                if (this.obj_awt['I'] == 0) {
                    this.obj_awt['DI'] = null;
                    this.obj_awt.BankList = [];
                }
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }

                this.getDataApi(`/api/dd/dn/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_do = d.dropdownlist
                        }
                    });


                if (agi > 0 && loadBankList) {
                    //banklist
                    this.getDataApi(`/api/cms/bl/${agi}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.obj_awt.BankList = d;
                            }
                        });                    
                }
            },
            DomainChange(value) {
                var that = this;
                this.dd_lang = [];
                if (value) {
                    this.getDataApi('/api/dd/dlang/' + value,
                        function (d, s) {
                            if (s) {
                                if (d.dropdownlist.length > 0) {
                                    that.dd_lang = d.dropdownlist;
                                    that.selectedLang = that.dd_lang[0];
                                }
                            }
                        });
                }
            },
            getCMSList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            path += ("f[" + this.str_FV[i].F + "][]=" + this.str_FV[i].FV);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                this.getDataApi(`/api/cms/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setCMSList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setCMSList(data) {
                this.arry_wtl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setCMS(data) {
                this.isDragDropMainMenu = false;
                this.isDragDropBankList = false;
                this.isDragDropNavMenu = false;
                this.obj_awt = data;
                this.boolSBL = this.obj_awt.SB
                this.boolSGL = this.obj_awt.SGL
                this.boolSSP = this.obj_awt.SSP
                this.boolSEP = this.obj_awt.SEP
                this.boolSPB = this.obj_awt.SPB
                this.boolBigImg = this.obj_awt.LIS
                this.bool_gps_one = true;
                this.bool_gps_two = false;
                this.bool_gps_three = false;
                if (this.obj_awt.SGP == 1) {
                    this.bool_gps_one = true;
                    this.boolSGP = true;
                }
                else if (this.obj_awt.SGP == 2) {
                    this.bool_gps_one = false;
                    this.bool_gps_two = true;
                    this.boolSGP = true;
                }
                else if (this.obj_awt.SGP == 3) {
                    this.bool_gps_one = false;
                    this.bool_gps_three = true;
                    this.boolSGP = true;
                }
                else {
                    this.boolSGP = false;
                }
                this.bool_isAMV = true;

                //BankList
                //this.obj_awt.BankList = [];
                this.DomainChange(this.obj_awt.DI);
                //if (this.obj_awt.CustomNavMenu) {
                //    this.obj_awt.CustomNavMenu.sort((a, b) => a.MN.toLowerCase() > b.MN.toLowerCase() ? 1 : -1);
                //}
            },
            addCMS() {
                this.obj_awt = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DI: null,
                    SB: 0,
                    SGL: 0,
                    SGP: 0,
                    SSP: 0,
                    SEP: 0,
                    AGI: "",
                    AGIT: null,
                    SABL: true,
                    BankList: [],
                    CustomNavMenu: [],
                    MainMenu: [],
                    HDC: null,
                    ICC: false,
                    BGC: null,
                    BGBC: null
                };
                this.bool_CV = false;
                this.boolSBL = false;
                this.boolSGL = false;
                this.boolSGP = false;
                this.boolSSP = false;
                this.boolSEP = false;
                this.boolSPB = false;
                this.boolBigImg = false;
                this.bool_gps_one = true;
                this.bool_gps_two = false;
                this.bool_gps_three = false;
                this.str_gpStyle = "1";
                this.nav_menu = null;
                this.isDragDropMainMenu = false;
                this.isDragDropBankList = false;
                this.isDragDropNavMenu = false;
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_awt.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_awt.AGIT);
                    }
                }
                var that = this;
                this.getDataApi('/api/cms/dbnm',
                    function (d, s) {
                        if (s) {
                            if (d && d.length > 0) {
                                that.obj_awt.CustomNavMenu = d;
                                //that.obj_awt.CustomNavMenu.sort((a, b) => a.MN.toLowerCase() > b.MN.toLowerCase() ? 1 : -1);
                            }
                        }
                    });
                this.getDataApi('/api/cms/dmm',
                    function (d, s) {
                        if (s) {
                            if (d && d.length > 0) {
                                that.obj_awt.MainMenu = d;
                            }
                        }
                    });
                this.bool_isAMV = true;
            },

            ValidationErrMsg(value, key1="", key2 = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_awt[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[key1][key2]);
                    }
                }
            },

            ValidationBNMErrMsg(value, key1 = "", key2 = "") {

                if (this.bool_CVBNM) {

                    var validateObj = this.$v.obj_BNM[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[key1][key2]);
                    }
                }
            },
            saveCMS() {

                this.bool_CV = true;
                this.obj_awt.SB = this.boolSBL;
                this.obj_awt.SGL = this.boolSGL;
                this.obj_awt.SEP = this.boolSEP;
                this.obj_awt.LIS = this.boolBigImg;
                this.obj_awt.SSP = this.boolSSP;
                this.obj_awt.SPB = this.boolSPB;
                if (this.obj_awt.AGIT != null && this.obj_awt.AGIT.length > 0) {
                    var agi = this.obj_awt.AGIT.split("-");
                    this.obj_awt.AGI = agi[1];
                }

                if (this.boolSGP && this.str_gpStyle != "" && this.str_gpStyle != null) {
                    this.obj_awt.SGP = this.str_gpStyle;
                } else {
                    this.obj_awt.SGP = 0;
                }               
                this.$v.obj_awt.$touch();
                if (this.obj_awt.SABL) {
                    var beforeLogin = this.obj_awt.CustomNavMenu.filter(f => f.BAL == 1 && f.RS != 0);
                    for (var i = 0; i < beforeLogin.length; i++) {
                        if (beforeLogin[i].NMI == 1 || beforeLogin[i].NMI == 10) { // 1: Register | 10: Login
                            this.showErrorMessage(null, String.format(this.getLanguage["CFM"]["ALMN"], "Login or register"));
                            return;
                        }
                    }
                }
                var bCheckSeq = false;
                if (this.boolSBL) {
                    for (var i = 0; i < this.obj_awt.BankList.length; i++) {
                        if (isNaN(this.obj_awt.BankList[i].SN) || this.obj_awt.BankList[i].SN < 1 || this.obj_awt.BankList[i].SN > 100) {
                            bCheckSeq = true;
                            break;
                        }
                    }
                }

                if (bCheckSeq) {
                    //this.showErrorMessage(null, String.format(this.getLanguage["MDB"]["DUPSEQ"]));
                    this.showErrorMessage(null, String.format(this.getLanguage["CMS"]["SQNV"]));
                }
                else if (this.obj_awt.CustomNavMenu.filter(f => f.RS != 0 && f.BAL == 1).length != 5 || this.obj_awt.CustomNavMenu.filter(f => f.RS != 0 && f.BAL == 2).length != 5) {
                    this.showErrorMessage(null, String.format(this.getLanguage["CFM"]["NML5"]));
                } 
                else {
                    if (!this.$v.obj_awt.$error) {
                        var that = this;
                        this.bool_fullLoading = true;
                        this.bool_fullScreen = true;
                        this.postDataApi(`/api/cms/s`, this.obj_awt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.getCMSList();
                                }
                            });
                    } else {
                        //get the object for validating.
                        const validation = this.$v["obj_awt"];
                        if (!validation) {
                            return;
                        }

                        const input = this.findRequiredInput(validation, this.$refs);
                        if (!input || typeof input.focus !== "function") {
                            return;
                        }

                        input.focus();
                    }

                }
            },
            editCMS(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/cms/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setCMS(d.D);
                            that.bool_isAMV = false;
                            if (that.obj_awt.AGI != 0) {
                                that.obj_awt.AGIT = "3-" + that.obj_awt.AGI;
                                that.AgentGroupChange(that.obj_awt.AGIT, false);
                            }
                            that.bool_isAMV = true;
                        }
                    });
            },
            removeCMS(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            di: d.DI
                        };

                        this.postDataApi(`/api/cms/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getCMSList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            returnStatus(status) {
                if (status) {
                    return "1";
                } else {
                    return "0";
                }
            },
            returnFrontStatus(status) {
                if (status == "1") {
                    return true;
                } else {
                    return false;
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getCMSList();
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },         
            closeBNM() {                
                this.bool_CVBNM = false;
                this.bool_isBNM = !this.bool_isBNM;
            },
            closeMM() {
                this.bool_CVBNM = false;
                this.bool_isMM = !this.bool_isMM;
            },
            addBNM() {
                const before = this.obj_awt.CustomNavMenu.find((f) => (this.nav_menu && f.NMI == this.nav_menu && f.RS != 0 && f.BAL == 1));
                const after = this.obj_awt.CustomNavMenu.find((f) => (this.nav_menu && f.NMI == this.nav_menu && f.RS != 0 && f.BAL == 2));
                if (before && after) {
                    this.showErrorMessage(null, this.getLanguage["CFM"]["MEXIST"]);
                } else {
                    var selectedMenu = this.dd_nav_menu.find((f) => this.nav_menu && f.id == this.nav_menu)
                    if (!before) {
                        this.obj_awt.CustomNavMenu.push({
                            NMI: Number(selectedMenu.id),
                            MN: selectedMenu.label,
                            BAL: 1,
                            SN: 100,
                            RS: 2,
                            I: 0,
                            IsEdit: true
                        });
                    }
                    if (!after) {
                        if (this.nav_menu == 1 || this.nav_menu == 10) {
                            this.showErrorMessage(null, String.format(this.getLanguage["CFM"]["ALMN"], selectedMenu.label));
                        } else {
                            this.obj_awt.CustomNavMenu.push({
                                NMI: Number(selectedMenu.id),
                                MN: selectedMenu.label,
                                BAL: 2,
                                SN: 100,
                                RS: 2,
                                I: 0,
                                IsEdit: true
                            });
                        }
                    }
                    //this.obj_awt.CustomNavMenu.sort((a, b) => a.MN.toLowerCase() > b.MN.toLowerCase() ? 1 : -1);
                }
                this.nav_menu = null;
            },
            addNMM() {
                const tempMenu = this.obj_awt.MainMenu.find((f) => (this.main_menu && f.MMI == this.main_menu && f.RS != 0));
                if (tempMenu) {
                    this.showErrorMessage(null, this.getLanguage["CFM"]["MEXIST"]);
                } else {
                    var selectedMenu = this.dd_main_menu.find((f) => this.main_menu && f.id == this.main_menu)
                    if (!tempMenu) {
                        this.obj_awt.MainMenu.push({
                            MMI: Number(selectedMenu.id),
                            MN: selectedMenu.label,
                            SN: 100,
                            RS: 2,
                            I: 0,
                            IsEdit: true
                        });
                    }
                }
                this.main_menu = null;
            },
            TBCColorChange(value) {
                this.obj_awt.BGBC = value;
            },
            TCColorChange(value) {
                this.obj_awt.BGC = value;
            },
            removeNavMenu(id, MenuId, login) {
                for (var i = 0; i < this.obj_awt.CustomNavMenu.length; i++) {
                    if (this.obj_awt.CustomNavMenu[i].I == id && this.obj_awt.CustomNavMenu[i].NMI == MenuId && this.obj_awt.CustomNavMenu[i].BAL == login && this.obj_awt.CustomNavMenu[i].BAL != 3) {
                        this.obj_awt.CustomNavMenu[i].RS = 0;
                        this.obj_awt.CustomNavMenu[i].SN = 100;
                        this.obj_awt.CustomNavMenu[i].IsEdit = this.obj_awt.CustomNavMenu[i].I > 0;
                        break;
                    }
                }
                this.obj_awt.CustomNavMenu.sort((a, b) => a.SN > b.SN ? 1 : -1);
            },
            removeMainMenu(id, MenuId) {
                for (var i = 0; i < this.obj_awt.MainMenu.length; i++) {
                    if (this.obj_awt.MainMenu[i].I == id && this.obj_awt.MainMenu[i].NMI == MenuId) {
                        this.obj_awt.MainMenu[i].RS = 0;
                        this.obj_awt.MainMenu[i].SN = 100;
                        this.obj_awt.MainMenu[i].IsEdit = this.obj_awt.MainMenu[i].I > 0;
                        break;
                    }
                }
                this.obj_awt.MainMenu.sort((a, b) => a.SN > b.SN ? 1 : -1);
            },
            editMenu(data) {
                if (!this.obj_awt.DI) {
                    this.showErrorMessage(null, this.getLanguage["T5"]["SDF"]);
                    return;
                }
                this.obj_BNM = data;
                if (this.dd_lang && this.dd_lang.length > 0) {
                    this.selectedLang = this.dd_lang[0];
                    this.obj_BNM.TMNL = [];
                    if (this.obj_BNM.TMN) {
                        var bn = [];
                        var bnl = [];
                        bn = this.obj_BNM.TMN.split("{<=}");
                        if (bn.length > 0) {
                            bn.forEach(function (item) {
                                var row = item.split("{=>}");
                                bnl[row[0]] = row[1];
                            });
                        }
                        this.obj_BNM.TMNL = bnl;
                    }
                    if (!this.obj_BNM.TMNL['en']) {
                        this.obj_BNM.TMNL['en'] = this.obj_BNM.MN;
                    }
                }
                this.bool_CVBNM = false;
                this.bool_isBNM = true;
            },
            saveMenu() {
                this.bool_CVBNM = true;
                this.$v.obj_BNM.$touch();
                if (!this.$v.obj_BNM.$error) {
                    var bnl = [];
                    this.obj_BNM.IsEdit = true;
                    this.obj_BNM.TMN = null;
                    Object.keys(this.obj_BNM.TMNL).forEach(key => {
                        if (this.obj_BNM.TMNL[key] != '')
                            bnl.push(key + "{=>}" + this.obj_BNM.TMNL[key]);
                    });
                    if (bnl.length > 0) {
                        this.obj_BNM.TMN = bnl.join("{<=}");
                    }
                    for (var i = 0; i < this.obj_awt.CustomNavMenu.length; i++) {
                        if (this.obj_awt.CustomNavMenu[i].BAL == this.obj_BNM.BAL && this.obj_awt.CustomNavMenu[i].NMI == this.obj_BNM.NMI && this.obj_awt.CustomNavMenu[i].RS != 0) {
                            this.obj_awt.CustomNavMenu[i] = this.obj_BNM;
                            break;
                        }
                    }
                    this.bool_CVBNM = false;
                    this.bool_isBNM = false;
                }
            },
            editMainMenu(data) {
                if (!this.obj_awt.DI) {
                    this.showErrorMessage(null, this.getLanguage["T5"]["SDF"]);
                    return;
                }
                this.obj_MM = data;
                if (this.dd_lang && this.dd_lang.length > 0) {
                    this.selectedLang = this.dd_lang[0];
                    this.obj_MM.TMNL = [];
                    if (this.obj_MM.TMN) {
                        var bn = [];
                        var bnl = [];
                        bn = this.obj_MM.TMN.split("{<=}");
                        if (bn.length > 0) {
                            bn.forEach(function (item) {
                                var row = item.split("{=>}");
                                bnl[row[0]] = row[1];
                            });
                        }
                        this.obj_MM.TMNL = bnl;
                    }
                    if (!this.obj_MM.TMNL['en']) {
                        this.obj_MM.TMNL['en'] = this.obj_MM.MN;
                    }
                }
                this.bool_CVMM = false;
                this.bool_isMM = true;
            },
            saveMainMenu() {
                this.bool_CVMM = true;
                var bnl = [];
                this.obj_MM.IsEdit = true;
                this.obj_MM.TMN = null;
                Object.keys(this.obj_MM.TMNL).forEach(key => {
                    if (this.obj_MM.TMNL[key] != '')
                        bnl.push(key + "{=>}" + this.obj_MM.TMNL[key]);
                });
                if (bnl.length > 0) {
                    this.obj_MM.TMN = bnl.join("{<=}");
                }
                for (var i = 0; i < this.obj_awt.MainMenu.length; i++) {
                    if (this.obj_awt.MainMenu[i].MMI == this.obj_MM.MMI && this.obj_awt.MainMenu[i].RS != 0) {
                        this.obj_awt.MainMenu[i] = this.obj_MM;
                        break;
                    }
                }
                this.bool_CVMM = false;
                this.bool_isMM = false;
            },
            needURL(BottomMenuId) {
                const menu = [5, 9, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
                return menu.includes(BottomMenuId);
            },
            renderCategoryNameForafbMainMenu(categoryName) {
                categoryName = categoryName.replaceAll(" ", "")
                if (categoryName && categoryName in this.getLanguage['AGD']) {
                    return this.getLanguage['AGD'][categoryName];
                }
                else if (categoryName && categoryName in this.getLanguage['CMSM']) {
                    return this.getLanguage['CMSM'][categoryName];
                }
                else {
                    return categoryName;
                }
            },
            renderCategoryNameForBottomNav(categoryName) {
                categoryName = categoryName.replaceAll(" ", "")
                if (categoryName && categoryName in this.getLanguage['CFM']) {
                    return this.getLanguage['CFM'][categoryName];
                }
                else {
                    return categoryName;
                }
            },
            
        },
        watch: {
            // bool_obj_FMS(newValue) {
            //     if (newValue == true) {
            //         this.obj_awt["RS"] = "2"
            //     } else {
            //         this.obj_awt["RS"] = "1"
            //     }
            // },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isBNM() {
                if (!this.bool_isBNM && this.bool_CVBNM) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isMM() {
                if (!this.bool_isMM && this.bool_CVMM) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getDropDownList();
                this.getCMSList();
            },
            'obj_awt.MainMenu'() {
                if (this.isDragDropMainMenu && this.obj_awt.MainMenu != null && this.obj_awt.MainMenu.length > 0) {
                    this.obj_awt.MainMenu.filter(f => f.RS != 0).forEach((data, index) => {
                        if (data.SN != index + 1) {
                            data.SN = index + 1;
                            data.IsEdit = true;
                        }
                    });
                } else {
                    this.isDragDropMainMenu = true;
                }
            },
            'obj_awt.CustomNavMenu'() {
                if (this.isDragDropNavMenu && this.obj_awt.CustomNavMenu != null && this.obj_awt.CustomNavMenu.length > 0) {
                    this.obj_awt.CustomNavMenu.filter(f => f.RS != 0).forEach((data, index) => {
                        if (data.SN != index + 1) {
                            data.SN = index + 1;
                            data.IsEdit = true;
                        }
                    });
                } else {
                    this.isDragDropNavMenu = true;
                }
            },
            'obj_awt.BankList'() {
                if (this.isDragDropBankList && this.obj_awt.BankList != null && this.obj_awt.BankList.length > 0) {
                    this.obj_awt.BankList.filter(f => f.RS != 0).forEach((data, index) => {
                        if (data.SN != index + 1) {
                            data.SN = index + 1;
                            data.IsEdit = true;
                        }
                    });
                } else {
                    this.isDragDropBankList = true;
                }
            }
        },
    }
</script>

<style>
    .vue-swatches__trigger {
        width: 170px !important;
        height: 30px !important;
        border-radius: 4px !important;
        outline: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/ContentManagementSystem/FooterMenu.vue